<template>
  <div id="app">
      <div class="maincon">
        <div class="tab-tilte">
          <p @click="package=0" :class="{active:package==0}" style="margin-left: 0;cursor: pointer;">资源包分类</p>
          <p @click="packageBZ" :class="{active:package==1}" style="cursor: pointer;">标准资源包</p>
          <p @click="packageZDY" :class="{active:package==2}" style="cursor: pointer;">自定义资源包</p>
        </div>
        <div class="tab-content">
           <RClass v-show="package==0"></RClass>
          <RCustom v-show="package==1" ref="RCustom"></RCustom>
          <RStandard v-show="package==2" ref="RStandard"></RStandard>
        </div>

</div>
  </div>

</template>

<script>
  import RClass from './Class';
  import RStandard from './Standard.vue';
  import RCustom from './Custom.vue';



  export default {
    data() {
      return {
        package: 0,
      }
    },
    components: {
      RClass: RClass,
      RStandard: RStandard,
      RCustom: RCustom,
    },
      methods: {
	   packageBZ(){
       let _this=this
       _this.package=1
       this.$refs.RCustom.get_train_resource();
       this.$refs.RCustom.get_train_video();
       this.$refs.RCustom.get_type();
	   },
	   packageZDY(){
       let _this=this
       _this.package=2
       this.$refs.RStandard.get_train_resource();
       this.$refs.RStandard.get_train_video();
       this.$refs.RStandard.get_type();
	   }
      },

  }
</script>

<style scoped>



  .maincon {
   padding: 20px;
   height: calc(100vh - 40px);
   overflow-y: auto;
  }

  .tab-tilte {
    height: 41px;
  }

  .tab-tilte>p {
    float: left;
    margin: 0 5px;
    padding: 10px 15px;
    background-color: white;
    border: 1px solid #DCDCDC;
    border-bottom: none;
    border-radius: 5px 5px 0 0;
    font-size: 15px;
  }

  .active {

    border-bottom: 1px solid white !important;
  }

  .tab-content {
    background-color: white;
    border: 1px solid #DCDCDC;
    min-height: calc(100% - 83px);
    border-radius: 0px 5px 5px 5px;
    padding: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/view/company/train/ResourcesPack/Resources.vue